import { isFirefox } from '@/utils/browser-kit';
import { cleanAndUnescapeHtml } from './base';

export const findLastTextNode = (node: Node): Node | null => {
    if (node.nodeType === Node.TEXT_NODE) {
        return node;
    }

    for (let i = node.childNodes.length - 1; i >= 0; i--) {
        const lastChild = node.childNodes[i];
        if (lastChild.nodeType === Node.TEXT_NODE) {
            return lastChild;
        }
        if (lastChild.nodeType === Node.ELEMENT_NODE) {
            const textNode = findLastTextNode(lastChild);
            if (textNode) return textNode;
        }
    }

    return null;
};

export const findPreviousTextNode = (container: Node, root: Node): Node | null => {
    // 遍历当前节点的前一个兄弟节点，直到遇到根节点
    let current = container;
    while (current.parentNode) {
        if (current.parentNode.isSameNode(root)) {
            break;
        }

        let sibling = current.previousSibling;
        while (sibling) {
            if (sibling.nodeType === Node.TEXT_NODE) {
                return sibling;
            }
            const textNode = findLastTextNode(sibling);
            if (textNode) {
                return textNode;
            }
            sibling = sibling.previousSibling;
        }
        current = current.parentNode;
    }

    return null;
};

/**
 * 检查节点及其子节点中是否存在文本节点
 */
export const checkHasTextNode = (node: Node): boolean => {
    if (node.nodeType === Node.TEXT_NODE && node.textContent != null) {
        return true;
    }

    let child = node.firstChild;
    while (child) {
        if (checkHasTextNode(child)) {
            return true;
        }
        child = child.nextSibling;
    }

    return false;
};

/**
 * 保证编辑区有默认结构，通常在进入编辑态和删除文本内容时调用
 * 主要是为了保证编辑区有默认结构，避免出现内容没有被默认的 span 标签包裹
 * @param container - 编辑区 dom 节点
 * @returns
 */
export const ensureEditAreaHasDefaultStruct = (container: HTMLDivElement) => {
    const defaultInnerHTML = '<span data-custom="0"><br></span>';
    container.innerHTML = defaultInnerHTML;

    const selection = window.getSelection();
    const range = document.createRange();

    const span = container.querySelector('span[data-custom="0"]');
    if (span && selection) {
        // 设置光标位置到 br 标签之前
        range.setStart(span, 0);
        range.setEnd(span, 0);

        selection.removeAllRanges();
        selection.addRange(range);
    }
};

export const insertPlainText = (text: string) => {
    if (document.queryCommandSupported('insertHTML') || document.queryCommandSupported('insertText')) {
        if (isFirefox) {
            document.execCommand('insertText', false, text);
        } else {
            document.execCommand('insertHTML', false, cleanAndUnescapeHtml(text, { trimEndNewline: false }));
        }
    } else {
        document.execCommand('paste', false, text);
    }
};
